import BlockComponentMap from '../../../models/BlockComponentValues/BlockComponentMap';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockiFrameData {
  html: BlockComponentMap;
  text: BlockComponentText;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockiFrameData {
  export function make(html?: string, text?: string, url?: string): BlockiFrameData {
    return {
      html: BlockComponentMap.make(html),
      text: text ? BlockComponentText.make(text) : undefined,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(html: string = undefined, text = '説明文'): BlockiFrameData {
    return make(html, text);
  }
}

export default BlockiFrameData;
